// extracted by mini-css-extract-plugin
export default {"productPage":"style_productPage__6L6pr","productList":"style_productList__W3ckP"};